export const COLORS = [
  '#ff000000', '#d50000', '#2979ff', '#ffd600',
  '#00c853', '#ff6d00', '#651fff', '#9e9e9e'
]

export const getRealColor = color => {
  if (color.index >= 0) {
    return COLORS[color.index]
  } else {
    return color.custom
  }
}
